// extracted by mini-css-extract-plugin
module.exports = {"OnePercentIntro":"OnePercentIntro_OnePercentIntro__z10Ey"};